import React from 'react';
import './App.css';
import BuildYourBundle from './BuildYourBundle';

function App() {
  return (
    <div className="App">
      <BuildYourBundle />
    </div>
  );
}

export default App;
